import React from 'react';
import { StateEnum } from 'constants/state';
import { FormInstance } from 'antd';
import {
  Input,
  Modal,
  Select,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
  AddressInline,
  NotesInline,
  InlineFormGroup,
  InlineButton,
} from './style';

export interface AddClientLocationFormData {
  name?: string
  maintainer?: string
  state?: StateEnum
  city?: string
  phone?: string
  cpf?: string
  cnpj?: string
  stateRegistration?: string
  notes?: string
}

interface LocationModalProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  onCancel(): void
  curLocation?: AddClientLocationFormData
  isVisible: boolean
}

const LocationModal = ({
  formHandler,
  onSubmit,
  onCancel,
  curLocation,
  isVisible,
}: LocationModalProps): JSX.Element => (
  <Modal
    visible={isVisible}
    title="Nova localização"
    destroyOnClose
    onCancel={onCancel}
    footer={[
      <InlineButton
        key="cancel"
        onClick={onCancel}
        type="ghost"
      >
        Cancelar
      </InlineButton>,
      <InlineButton
        key="submit"
        onClick={() => formHandler.submit()}
      >
        Salvar localização
      </InlineButton>,
    ]}
  >
    <FormContainer
      layout="vertical"
      form={formHandler}
      requiredMark={false}
      onFinish={onSubmit as (val: unknown) => void}
    >
      <BaseFormItem
        label="Encarregado"
        name="maintainer"
        initialValue={curLocation?.maintainer}
      >
        <Input />
      </BaseFormItem>
      <BaseFormItem
        label="Fazenda"
        name="name"
        initialValue={curLocation?.name}
      >
        <Input />
      </BaseFormItem>
      <AddressInline>
        <BaseFormItem
          label="Cidade"
          name="city"
          className="city-input"
          initialValue={curLocation?.city}
        >
          <Input />
        </BaseFormItem>
        <BaseFormItem
          label="Estado"
          name="state"
          className="state-input"
          initialValue={curLocation?.state || StateEnum.AC}
        >
          <Select>
            {Object.values(StateEnum).map((state) => (
              <Select.Option value={state} key={state}>{state}</Select.Option>
            ))}
          </Select>
        </BaseFormItem>
      </AddressInline>
      <BaseFormItem
        label="Telefone"
        name="phone"
        initialValue={curLocation?.phone}
      >
        <Input />
      </BaseFormItem>
      <InlineFormGroup>
        <BaseFormItem
          label="CPF"
          name="cpf"
          className="cpf-input"
          initialValue={curLocation?.cpf}
        >
          <Input />
        </BaseFormItem>
        <BaseFormItem
          label="CNPJ"
          name="cnpj"
          className="cnpj-input"
          initialValue={curLocation?.cnpj}
        >
          <Input />
        </BaseFormItem>
      </InlineFormGroup>
      <BaseFormItem
        label="Inscrição estadual"
        name="stateRegistration"
        initialValue={curLocation?.stateRegistration}
      >
        <Input />
      </BaseFormItem>
      <NotesInline
        label="Observações"
        name="notes"
        initialValue={curLocation?.notes}
      >
        <Input.TextArea rows={5} />
      </NotesInline>
    </FormContainer>
  </Modal>
);

LocationModal.defaultProps = {
  curLocation: undefined,
};

export default LocationModal;
